import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class TeamsAlertsService {

  constructor(private bringozToastService: BringozToastService) {
  }

// CREATE //
  createSuccess() {
    const message = {
      body: 'TEAM_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'TEAM_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EDIT //
  editSuccess() {
    const message = {
      body: 'TEAM_EDIT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  editError() {
    const message = {
      body: 'TEAM_EDIT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteSuccess() {
    const message = {
      body: 'TEAM_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteError() {
    const message = {
      body: 'TEAM_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.teams')
  .service('teamsAlertsService', TeamsAlertsService);
